import { memo, useCallback } from 'react';

import { SidebarResizer } from '@air/component-sidebar';

import { useSubSideNavStore } from '~/components/v2/store/features/workspace/useSubSideNavStore';
import { SIDEBAR_SIZE } from '~/constants/localStorageKeys';
import { CURRENT_WORKSPACE_NAV_WIDTH } from '~/constants/sideNav';
import { setSubSideNavContentWidth, setSubSideNavWidth } from '~/utils/subscribeSubSideNavWidthSync';

export type SubSideNavResizerProps = {
  collapsible: boolean;
};

export const SubSideNavResizer = memo(({ collapsible }: SubSideNavResizerProps) => {
  const toggleOpen = useSubSideNavStore((state) => state.toggleOpen);
  const setIsResizing = useSubSideNavStore((state) => state.setIsResizing);

  const handleResizeStart = useCallback(() => {
    setIsResizing(true);
    setSubSideNavWidth(true, true);
  }, [setIsResizing]);

  const handleResizeEnd = useCallback(() => setIsResizing(false), [setIsResizing]);

  const handleClose = useCallback(() => {
    setIsResizing(false);
    toggleOpen();
  }, [setIsResizing, toggleOpen]);

  return (
    <SidebarResizer
      className="items-end"
      localStorageKey={SIDEBAR_SIZE}
      onClose={collapsible ? handleClose : undefined}
      onResize={setSubSideNavContentWidth}
      onResizeEnd={handleResizeEnd}
      onResizeStart={handleResizeStart}
      size={CURRENT_WORKSPACE_NAV_WIDTH}
    />
  );
});

SubSideNavResizer.displayName = 'SubSideNavResizer';
